import * as React from 'react';
import Radio from '@mui/material/Radio';
import RadioGroup from '@mui/material/RadioGroup';
import FormControlLabel from '@mui/material/FormControlLabel';
import FormControl from '@mui/material/FormControl';
import FormLabel from '@mui/material/FormLabel';
import { useDispatch, useSelector } from 'react-redux';
import { IReduxState } from '../../store';
import { setdataFiltered } from '../../store/focusEcoleSlice';
import { Box } from '@mui/material';
import { IOptionChoisie } from '.';


export interface IOptionFilterProps {
    optionState: IOptionChoisie;
    setOptionState: (x: IOptionChoisie) => void;
}


export default function OptionFilter(props: IOptionFilterProps) {
    const { optionState, setOptionState } = props

    const dispatch = useDispatch();
    const { students, dataFiltered } = useSelector((state: IReduxState) => state.focusEcole);



    const handleInputChange = (e: any) => {
        const { value, name } = e.target
        setOptionState({ ...optionState, [name]: value })
    }


    return (
        <Box>
            <FormControl>
                <RadioGroup
                    row
                    name="optionChoisie"
                    onChange={handleInputChange}
                >
                    <FormControlLabel value="tout" checked={optionState.optionChoisie === "tout" ? true : false} control={<Radio color="error" />} style={{ color: 'red' }} label="Tout" />
                    <FormControlLabel value="nonsouscrit" checked={optionState.optionChoisie === "nonsouscrit" ? true : false} control={<Radio color="warning" />} style={{ color: "#FAAF00" }} label="Impayé" />
                    <FormControlLabel value="souscrit" checked={optionState.optionChoisie === "souscrit" ? true : false} control={<Radio color="success" />} style={{ color: 'green' }} label="Payé" />
                </RadioGroup>
            </FormControl>
        </Box>
    );
}
